import React from 'react';
import { useTranslation } from 'react-i18next';

import Fetchable from '~/commons/components/util/Fetchable';
import { resolvePath } from '~/commons/helpers';
import { Link } from 'react-router-dom';

import Html from '~/commons/components/util/Html';
import Page from '../../layout/Page';

const PageRankingRules = () => {
  const { i18n, t } = useTranslation();

  return (
    <Page>
      <Fetchable req={{ url: '/api/views/u?key=ranking-rules' }}>
        {(view) => (
          <div className="container">
            <div>
              <div className="row justify-content-center">
                <div className="col-11 col-lg-10">
                  <div className="position-relative text-center my-4 ">
                    <Link
                      to={resolvePath('../')}
                      className={`
                        position-absolute start-0 top-50 translate-middle-y
                        fw-bold btn-rock-3 fontBorder d-md-block d-none
                      `}
                    >
                      {t('nav.Back')}
                    </Link>
                    <h1 className="fw-bold">{i18n.pickLng(view.title)}</h1>
                  </div>
                  <Html>{i18n.pickLng(view.body)}</Html>
                  <div className="d-md-none d-flex justify-content-center">
                    <Link
                      to={resolvePath('../')}
                      className="position-absolute text-center fw-bold btn-rock-3 fontBorder"
                    >
                      {t('nav.Back')}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Fetchable>
    </Page>
  );
};

export default PageRankingRules;
